/*
const globalSuccess = response=> response;
const globalError = err=> err;
*/

export function isFile(o){ return ({}).toString.call(o) === '[object File]'; }
export function isFormData(o){ return o instanceof FormData; }

function object2params(o){
  return Object.keys(o).map(
            function(key){ return encodeURIComponent(key) + '=' + encodeURIComponent(o[key]) }
        ).join('&');
}

const single_request_keys = {};

export default function xhr(opts, xhrConfig={}){
  const request = new XMLHttpRequest();
  const headers = opts.headers || {};

  const promise = new Promise(function(resolve, reject){
    if(opts.method === 'GET' && opts.data){
      opts.url += '?' + object2params(opts.data);
      opts.data = undefined;
    }
    request.open(opts.method, opts.url, true);
    // request.withCredentials = xhrConfig.withCredentials !== false;
    request.withCredentials = false;
    request.responseType = 'json';
    request.setRequestHeader('Accept', 'application/json');
    if (opts.data) {
      if(xhrConfig.contentType){
        request.setRequestHeader('Content-Type', xhrConfig.contentType);
      } else if(isFile(opts.data)) {
        request.setRequestHeader('Content-Type', 'application/octet-stream');
      } else if(!isFormData(opts.data)) {
        request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      }
    }
    for (let header of Object.keys(headers)) {
      request.setRequestHeader(header, headers[header]);
    }
    request.onreadystatechange = function() {
      if (this.readyState !== this.DONE) { return; }
      if (200 <= this.status && this.status < 300) {
        return resolve(this.response, this.status);
      } else if (this.status) {
        return reject([this.status, this.response]);
      } else {
        return reject([this.status, "No Response"]);
      }
    };

    if (opts.onUploadProgress){
      request.upload.onprogress = opts.onUploadProgress;
    }
    if (opts.onUploadLoad){
      request.upload.onload = opts.onUploadLoad;
    }
    if (typeof xhrConfig === 'function') {
      xhrConfig(request);
    }

    const send = ()=> {
      if (opts.data) {
        const data = isFile(opts.data) || isFormData(opts.data) ? opts.data : JSON.stringify(opts.data);
        return request.send(data);
      }
      return request.send();
    };

    if (xhrConfig.single){
      if (single_request_keys[xhrConfig.single]) {
        single_request_keys[xhrConfig.single] = send;
      } else {
        single_request_keys[xhrConfig.single] = true;
        send();
      }
    } else {
      send();
    }
  });

  if(xhrConfig.single){
    promise.then(()=> {
      const queued = single_request_keys[xhrConfig.single];
      if(typeof(queued) === 'function'){
        queued();
      }
      single_request_keys[xhrConfig.single] = false;
    })
  }

  // and were coalescing rejections to resolutions
  const ret = promise; //.then(globalSuccess, globalError);
  ret.request = request;
  return ret;
};
